/* eslint-disable react-native/no-inline-styles */
import React, { memo, useCallback } from 'react'

import { FormControl, Select, MenuItem } from '@mui/material'

import { ViewColumnLine, CalculText } from './LineStyleComponent'

export type PickerMultiLineProps = {
  dataPicker1: Array<{ label: string; value: string }>
  dataPicker2: Array<{ label: string; value: string }>
  subtitle?: string
  id1: string
  id2: string
  disabled?: boolean
  title: string
  onChange: (ids1: string, ids2: string) => void
  first?: boolean
  last?: boolean
}

const PickerMultiLine = ({ id1, id2, dataPicker1, dataPicker2, subtitle, onChange, first, last }: PickerMultiLineProps) => {
  const _onChangePicker1 = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event: any) => {
      if (onChange) {
        onChange(String(event.target.value as string), id2)
      }
    },
    [id2, onChange]
  )

  const _onChangePicker2 = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event: any) => {
      if (onChange) {
        onChange(id1, String(event.target.value as string))
      }
    },
    [id1, onChange]
  )

  return (
    <ViewColumnLine first={first} last={last}>
      <div style={{ display: 'flex', width: '100%' }}>
        <FormControl sx={{ m: 1 }} fullWidth size="small">
          <Select labelId="demo-simple-select-label" id="demo-simple-select" value={id1} onChange={_onChangePicker1} fullWidth>
            {dataPicker1.map((item, index) => {
              return (
                <MenuItem value={item.value} key={`pickerLineMulti_${index}`}>
                  {item.label}
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1 }} fullWidth size="small">
          <Select labelId="demo-simple-select-label" id="demo-simple-select" value={id2} onChange={_onChangePicker2} fullWidth>
            {dataPicker2.map((item, index) => {
              return (
                <MenuItem value={item.value} key={`pickerLine_${index}`}>
                  {item.label}
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
      </div>
      <CalculText>{subtitle}</CalculText>
    </ViewColumnLine>
  )
}

export default memo(PickerMultiLine)
